<template>
  <div class="container mt-3">
    <div class="mt-3">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/"><i class="fas fa-home"></i></router-link>
          </li>
          <li class="breadcrumb-item active">Kursus</li>
        </ol>
      </nav>
    </div>

    <div class="container-box mt-3">
      <div class="header-box">
        <div class="row mx-0">
          <div class="col-8">
            <div class="box-left">
              <h1>Selamat Datang.</h1>
              <h5>
                Teruskan mempelajari ilmu berkaitan ibadat Haji!
              </h5>
            </div>
          </div>
        </div>
      </div>

      <div class="contents mt-3">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a
              href="#"
              class="nav-link active"
              >Utama</a
            >
          </li>
        </ul>

        <div class="nav-contents mt-3">
          <div class="row mx-0 g-2">
            <div
              class="col-12"
              v-for="course in filteredCourses"
              :key="course.id"
            >
              <div
                class="course-box position-relative"
                :class="{ 'course-box-blue' : true }"
                @click="goto(`/public-courses/courses/${course.id}`, course)"
              >
                <div class="box-featured-img" :style="courseBoxBg()"></div>
                <div class="course-box-inner position-relative p-3">
                  <div class="row mx-0">
                    <div class="col-6 col-sm-8 col-md-10">
                      <h5>{{ course.attributes.course_name }}</h5>
                    </div>
                    <div class="col-6 col-sm-4 col-md-2">
                      <div class="d-flex justify-content-end align-items-center h-100">
                        <span class="span-click"
                          >Klik untuk masuk <i class="fas fa-arrow-right"></i
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="filteredCourses.length <= 0" class="nav-contents mt-3">
              <i>Tiada</i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import API from "../../../utils/API";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      courses: [],
      filteredCourses: [],
    };
  },
  computed: {
    ...mapGetters(["currentUserAccessType"]),
  },
  methods: {
    async goto(_path, _course) {
      this.$router.push(_path);
    },
    courseBoxBg() {
      let randomNumber = Math.ceil(Math.random() * 4);
      return `
                background-image: url(/img/random/featured-img-${randomNumber}.jpg);
                background-size: cover;
                background-repeat: no-repeat;
                `;
    },
  },
  async mounted() {
    let userAccessTypesFilter
    if(!this.currentUserAccessType) userAccessTypesFilter = { name: { $eq: 'public' } }
    else userAccessTypesFilter = { id: { $eq: this.currentUserAccessType.id } }

    const queryParams = qs.stringify({
      filters: {
        user_access_types: userAccessTypesFilter,
        is_active: {
          $eq: true
        },
        course_type: {
          $eq: 'online'
        }
      }
    }, {
      encodeValuesOnly: true
    })
    let url =
      `courses?${queryParams}`;

    const res = await API.get(url);

    this.courses = res.data.data;

    //sort courses
    this.courses = this.courses.sort((itemA, itemB) => {
      let x = itemA.attributes.course_name.toLowerCase();
      let y = itemB.attributes.course_name.toLowerCase();
      if (x < y) {
        return -1;
      }
      if (x > y) {
        return 1;
      }
      return 0;
    });

    this.filteredCourses = this.courses;
  },
};
</script>